import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../Icon/Icon'

import StarsRating from '../StarsRating'
import UserAvatar from '../UserAvatar/UserAvatar'

class UserBox extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.isActive && this.props.isActive !== prevProps.isActive) {
      this.props.updateActiveUser(this.props.isDisabled ? null : this.props.attributes)
    }
  }

  render() {
    const isDisabledClass = this.props.isDisabled ? 'is-disabled' : ''
    const isActiveClass = this.props.isActive ? 'is-active' : ''

    return (
      <div
        className={`user-box ${this.props.boxClass} ${isDisabledClass} ${isActiveClass}`}
        onClick={this.props.isDisabled ? () => {} : () => this.props.selectUser(this.props.attributes)}
      >
        <UserAvatar
          img={this.props.attributes.avatarUrl}
          className="user-box__avatar"
          userName={this.props.attributes.username}
        />

        <div className="user-box__info">
          <span className="user-box__user">
            {this.props.attributes.username}
            {this.props.attributes.fullName && this.props.attributes.fullName !== this.props.attributes.username && (
              <span className="user-box__full-name">({this.props.attributes.fullName})</span>
            )}
          </span>
          {this.props.attributes.designerScore && this.props.scope === 'sellers'
            && (
            <div className="user-box__rating">
              <StarsRating rating={this.props.attributes.designerScore} fractions={2} customClass="height-12" readonly />
              <span className="rating">
                <span className="text-semibold">{this.props.attributes.designerScore}</span>
                {this.props.attributes.designerScore !== 'N/A' && '/5'}
              </span>
            </div>
            )
          }
        </div>

        {this.props.removeUser && (
          <button
            type="button"
            onClick={() => this.props.removeUser(this.props.attributes)}
            className="btn btn-transparent user-box__remove"
          >
            <Icon type={['far', 'times']} notSpaced />
          </button>
        )}
      </div>
    )
  }
}

UserBox.propTypes = {
  attributes: PropTypes.shape({
    id: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    fullName: PropTypes.string,
    username: PropTypes.string,
    designerScore: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }).isRequired,
  boxClass: PropTypes.string,
  selectUser: PropTypes.func,
  removeUser: PropTypes.func,
  isDisabled: PropTypes.bool,
  isActive: PropTypes.bool,
  scope: PropTypes.string.isRequired,
}

UserBox.defaultProps = {
  attributes: {
    avatarUrl: '',
    fullName: '',
    username: '',
    designerScore: null,
  },
  boxClass: '',
  selectUser: () => {},
  removeUser: null,
  isDisabled: false,
  isActive: false,
}

export default UserBox
